import { render, staticRenderFns } from "./TwitterGray.vue?vue&type=template&id=087c8b94&scoped=true&"
import script from "./TwitterGray.vue?vue&type=script&lang=js&"
export * from "./TwitterGray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c8b94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('087c8b94')) {
      api.createRecord('087c8b94', component.options)
    } else {
      api.reload('087c8b94', component.options)
    }
    module.hot.accept("./TwitterGray.vue?vue&type=template&id=087c8b94&scoped=true&", function () {
      api.rerender('087c8b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/icons/social/TwitterGray.vue"
export default component.exports